import React, {useState} from "react";
import {Container, Header, Icon} from "semantic-ui-react";
import AppListPage from "../../common/AppListPage";
import {SurveySelectionModel, SurveySelectionState, SurveySelectionStateToString} from "../model/SurveySelectionModel";
import {SurveySelectionListOptions} from "../model/SurveySelectionListOptions";
import {SurveySelectionDataProvider} from "../service/SurveySelectionDataProvider";
import {ColumnFormat} from "../../common/AppListDataGrid";
import SurveySelectionDetails from "./SurveySelectionDetails";
import {AppListMenuButton, defaultButtons} from "../../common/AppListMenu";
import styles from "./index.module.css";
import SurveySelectionExecuteStartModal from "./SurveySelectionExecuteStartModal";
import {hasRole, UserRole} from "../../../helpers/UserRole";

interface Props {
}

const SurveySelectionList = (props: Props) => {


    async function onButtonClick(button: string, focusedItem: SurveySelectionModel | undefined, reloadCallback?: () => void) {

        try {
            if (button == "execute" && focusedItem) {
                await (new SurveySelectionDataProvider()).execute(focusedItem.id);
                setExecuteStarted(true);

            }
        } catch (e) {
            alert(e);
            return;
        }
    }

    const [executeStarted, setExecuteStarted] = useState(false);

    return <Container fluid>
        <Header attached> <Icon name="question circle outline"/>Выборки</Header>
        {executeStarted && <SurveySelectionExecuteStartModal
            onClose={() => setExecuteStarted(false)}/>}

        <AppListPage<SurveySelectionModel, SurveySelectionListOptions>
            provider={new SurveySelectionDataProvider()}
            menuButtons={defaultButtons.concat([{
                key: "execute",
                name: "Выполнить",
                icon: "play",
                iconColor: "green"
            } as AppListMenuButton])}
            getDetailsComponent={(context) => <SurveySelectionDetails context={context}/>}
            newItemCreator={() => {
                return {id: "", name: "", createdAt: new Date(), conditions: [], state: SurveySelectionState.pending, countIncluded: 0}
            }}
            getDisabledButtons={(focusedItem?: SurveySelectionModel) => {
                let result: string[] = [];
                if (!focusedItem)
                    result.push('view', 'edit', 'delete', 'save');
                else if (focusedItem!.state == SurveySelectionState.executing
                    || focusedItem.state == SurveySelectionState.completed) result.push("save", "delete")
                if (hasRole(UserRole.OBSERVER)) result.push('edit', 'delete', 'add', 'load', 'save', 'execute');
                debugger;
                return result;
            }
            }
            onButtonClick={onButtonClick}

            columns={[
                {key: "name", name: "Наименование", cellClass: () => styles.cell_bolder},
                {
                    key: "countIncluded", name: "Выбрано",
                    width: 80,
                    cellClass: () => styles.cell_text_align_right
                },
                {
                    key: "state", name: "Состояние", accessor: (x) => SurveySelectionStateToString(x.state),
                    width: 180,
                    cellClass: (item) => {
                        switch (item.state) {
                            case SurveySelectionState.pending:
                                return styles.cell_state_pending;
                            case SurveySelectionState.executing:
                                return styles.cell_state_executing;
                            case SurveySelectionState.completed:
                                return styles.cell_state_completed;
                            case SurveySelectionState.error:
                                return styles.cell_state_error;
                        }
                    }
                },
                {
                    key: "createdAt", name: "Дата создания", format: ColumnFormat.datetime, sortDirection: "DESC",
                    cellClass: () => styles.cell_text_align_center,
                    width: 180,
                },
                {
                    key: "startedAt", name: "Дата начала", format: ColumnFormat.datetime,
                    cellClass: () => styles.cell_text_align_center,
                    width: 180,
                },
                {
                    key: "finishedAt", name: "Дата окончания", format: ColumnFormat.datetime,
                    cellClass: () => styles.cell_text_align_center,
                    width: 180,
                }
            ]}
        />
    </Container>;
}

export default SurveySelectionList;